
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.413 13.813L9.18 1.913a1.333 1.333 0 00-2.362 0l-6.232 11.9a1.333 1.333 0 001.182 1.952H14.23a1.333 1.333 0 001.182-1.952zm-8.08-7.718a.667.667 0 011.334 0v4a.667.667 0 11-1.334 0v-4zm.7 7.674h-.018A1.019 1.019 0 017 12.789a.984.984 0 01.965-1.02h.019a1.018 1.018 0 01.954 1.362.983.983 0 01-.905.638z","fill":"#E93653"}})])
          )
        }
      }
    